package com.eladfinish.bible.contest.extensions

/**
 * Normalizes an integer into the range 1..max in a cyclic way.
 *
 * Examples (max = 5):
 *  1  -> 1
 *  5  -> 5
 *  6  -> 1
 *  0  -> 5
 * -1  -> 4
 */
fun Int.normalize1To(max: Int): Int {
    require(max > 0) { "max must be positive" }
    return ((this - 1).mod(max)) + 1
}

fun Int.formatWithCommas(): String =
    this.toString().replace(Regex("""(\d)(?=(\d{3})+(?!\d))"""), "$1,")

fun Int.padZero(): String =
    toString().padStart(length = 2, padChar = '0')
